export default __webpack_public_path__ + "static/3-ccca3eb5b61ed52b943b3d7f2889628b.jpg";